<template>
    <v-container fluid class="py-0 d-flex justify-space-between">
        <div class="d-flex">
            <v-btn color="success" @click="categoryModal = !categoryModal">
                <fa
                    :icon="['fas', 'th']"
                    class="mr-2"
                    style="color: #fff"
                /><TranslatableStringComponent :tstring="{string: 'selectProductLine'}" /></v-btn
            >
            <v-chip-group
                v-if="hasAccessories"
                v-model="productLineType"
                @change="handleType($event)"
                mandatory
                active-class="success--text"
                class="ml-2 category-type"
            >
                <v-chip class="my-0" small outlined value="Products"
                    ><TranslatableStringComponent :tstring="{string: 'products'}" /></v-chip
                >
                <v-chip class="my-0" small outlined value="Accessories"
                    ><TranslatableStringComponent :tstring="{string: 'accessories'}" /></v-chip
                >
            </v-chip-group>
        </div>
        <div>
            <v-badge
                bordered
                color="secondary"
                :content="selectedFacetsCount"
                :value="selectedFacetsCount > 0"
                class="mr-2"
                overlap
            >
                <v-menu open-on-hover bottom left offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            color="success"
                            outlined
                            :disabled="productListWithAppliedPricelist.length === 0"
                            @click="facetModal = !facetModal"
                            v-bind="attrs"
                            v-on="on"
                            small
                        >
                            <fa
                                :icon="['fal', 'filter']"
                                class="mr-2"
                                style="color: #06a77d"
                            />
                            <span><TranslatableStringComponent :tstring="{string: 'filter'}" /></span></v-btn
                        >
                    </template>
                    <div style="background: #ffffff">
                        <div
                            v-if="selectedFacets"
                            class="pa-2 d-flex justify-end"
                        >
                            <v-btn
                                text
                                color="primary"
                                x-small
                                @click="facetModal = !facetModal"
                                ><TranslatableStringComponent :tstring="{string: 'change'}" /></v-btn
                            >
                            <v-btn
                                text
                                color="primary"
                                x-small
                                @click="clear_filter_in_route()"
                                ><TranslatableStringComponent :tstring="{string: 'clearAll'}" /></v-btn
                            >
                        </div>
                        <v-divider v-if="selectedFacets"></v-divider>
                        <div v-if="selectedFacets">
                            <v-list dense>
                                <v-list-item
                                    class="rem-border"
                                    v-for="(
                                        item, propertyName, index
                                    ) in selectedFacets"
                                    :key="index"
                                >
                                    <v-list-item-title
                                        >{{ propertyName }} :
                                        <b>{{ item.join('    |    ') }}</b>
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </div>
                        <div v-if="!selectedFacets" class="pa-4">
                            <v-btn
                                color="primary"
                                @click="facetModal = !facetModal"
                                small
                                ><TranslatableStringComponent :tstring="{string: 'changeFilters'}" /></v-btn
                            >
                        </div>
                    </div>
                </v-menu>
            </v-badge>

            <v-btn
                small
                outlined
                color="primary"
                :disabled="productListWithAppliedPricelist.length === 0"
                @click="handleExport()"
                :loading="exportLoading"
            >
                <fa :icon="['fal', 'file-csv']" class="mr-2 fa-lg" /><span
                    ><TranslatableStringComponent :tstring="{string: 'export'}" /></span
                ></v-btn
            >
        </div>
        <v-dialog v-model="categoryModal" max-width="70%">
            <ShopPageNavigationMenu
                :showHeading="true"
                @handleCategoryModal="categoryModal = !categoryModal"
            />
        </v-dialog>
        <v-dialog v-model="facetModal" persistent max-width="992px">
            <ShopFacets
                v-if="facetModal"
                :facets="facets"
                @handleFacetModal="facetModal = !facetModal"
                :validFacets="validFacets"
                v-model="selectedFacets"
            />
        </v-dialog>
    </v-container>
</template>

<script>
import ShopPageNavigationMenu from '~/components/shop/shopUtilities/ShopPageNavigationMenu.vue'
import ShopFacets from '~/components/shop/shopUtilities/ShopFacets.vue'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'
import { mapState, mapGetters } from 'vuex'
export default {
    name: 'ShopFilterPanel',
    components: {
        ShopPageNavigationMenu,
        ShopFacets,
        TranslatableStringComponent,
    },
    data() {
        return {
            facetModal: false,
            categoryModal: false,
            productLineType: '',
        }
    },
    props: {
        facets: {
            type: Array,
            default: () => [],
        },
        productList: {
            type: Array,
            default: () => [],
        },
        validFacets: {
            type: Array,
            default: () => [],
        },
    },
    mounted() {
        this.setProductLineType()
    },
    watch: {
        '$route.query': {
            handler: function () {
                this.setProductLineType()
            },
            deep: true,
        },
    },
    computed: {
        ...mapState('common', ['categories']),
        ...mapState('shop', ['exportLoading', 'selectedCategory']),
        ...mapGetters({
            productListWithAppliedPricelist:
                'shop/productListWithAppliedPricelist',
        }),
        selectedFacets() {
            const decodedFilterObj =
                this.$route.query.filter &&
                this.isBase64(this.$route.query.filter)
                    ? JSON.parse(window.atob(this.$route.query.filter))
                    : null
            return decodedFilterObj
        },
        selectedFacetsCount() {
            return this.selectedFacets
                ? Object.keys(this.selectedFacets).length
                : 0
        },
        hasAccessories() {
            return !!this.categories.find(
                (i) =>
                    i.title.en ===
                    this.$route.query.Categories?.replace(' Accessories', '')
            )?.showAccessoriesInShop
        },
    },
    methods: {
        setProductLineType() {
            this.productLineType = this.$route.query.Categories?.includes(
                'Accessories'
            )
                ? 'Accessories'
                : 'Products'
        },
        handleType(newVal) {
            const newCategory =
                newVal === 'Accessories'
                    ? `${this.$route.query.Categories} Accessories`
                    : this.$route.query.Categories.replace(' Accessories', '')
            this.$router.push({
                path: '/shop',
                query: {
                    Categories: newCategory,
                },
            })
        },
        clear_filter_in_route() {
            const query = {
                Categories: this.$route.query.Categories,
            }
            this.$router.push({
                query,
            })
        },
        isBase64(str) {
            if (typeof str !== 'string' && !process.client) {
                return false
            }
            try {
                return window.btoa(window.atob(str)) == str
            } catch (err) {
                return false
            }
        },
        handleExport() {
            this.$store.dispatch('shop/handleExport')
        },
    },
}
</script>

<style lang="scss" scoped>
.rem-border {
    border: 0;
}
</style>
